
import { SnackbarProgrammatic as Snackbar } from 'buefy'
import API from '@/api'

const actions = {
  getCollection({ commit }, payload) {
    API.events.getCollection(payload)
      .then(({ data: { data: { results }, include, meta } }) => {
        if (meta.page === 1) {
          commit('updateFiltersCollection', include.filters)
          commit('setIsContols', true)
          commit('setCollection', results)
        } else {
          commit('updateCollection', results)
        }

        commit('setPagination', meta)
      })
      .catch(() => {
        commit('setCollection', [])
        commit('setHasError', true)
      })
      .finally(() => {
        commit('setIsLoading', false)
        commit('setIsLoadingMore', false)
      })
  },
  getEvent({ commit }, id) {
    API.events.getEvent(id)
      .then(({ data: { data } }) => {
        commit('setEditForm', data)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Произошла ошибка при загрузке мероприятия',
          position: 'is-top-right',
          type: 'is-danger'
        })

        commit('updateEditFormModal', {
          active: false
        })
        commit('updateProgramModal', {
          active: false
        })
      })
      .finally(() => {
        commit('updateEditFormModal', {
          isLoading: false
        })
        commit('updateProgramModal', {
          isLoading: false
        })
      })
  },
  create({ commit, dispatch }, payload) {
    API.events.create(payload)
      .then(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Успешно</span>Мероприятие успешно создано.',
          position: 'is-top-right',
          type: 'is-success'
        })

        dispatch('updateLocalList')

        commit('updateEditFormModal', {
          active: false,
          header: null
        })
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Мероприятие не было создано.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateEditFormModal', {
          isLoading: false
        })
      })
  },
  update({ commit, dispatch }, { id, data }) {
    API.events.update({ id, data })
      .then(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Успешно</span>Детали мероприятия изменены.',
          position: 'is-top-right',
          type: 'is-success'
        })

        dispatch('updateLocalList')

        commit('updateEditFormModal', {
          active: false,
          header: null
        })
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Детали мероприятия не были изменены.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateEditFormModal', {
          isLoading: false
        })
      })
  },
  remove({ commit, dispatch }, id) {
    API.events.remove(id)
      .then(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Успешно </span>Мероприятие было удалено.',
          position: 'is-top-right',
          type: 'is-success'
        })

        dispatch('updateLocalList')
      })
      .catch(() => {
        commit('setIsLoading', false)

        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Мероприятие не было удалено.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
  },
  getResponsibleUsers({ commit }) {
    API.bitrix.getUsers()
      .then(({ data: { data: { results } } }) => {
        commit('setResponsibleUsers', results)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Список получателей запроса не был загружен.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateEditFormModal', {
          isLoading: false
        })
      })
  },
  createLead({ commit }, payload) {
    API.bitrix.createLead(payload)
      .then(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Успешно</span>Заявка на участие в мероприятии была отправлена.',
          position: 'is-top-right',
          type: 'is-success'
        })

        commit('updateParticipationFormModal', {
          active: false,
          showPassportForm: false,
          header: null
        })
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Заявка на участие в мероприятии не была отправлена.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('updateParticipationFormModal', {
          isLoading: false
        })
      })
  },
  updateLocalList({ commit, dispatch, getters }) {
    commit('setCollection', [])
    commit('setIsLoading', true)
    commit('setIsLoadingMoreBlocked', false)
    dispatch('getCollection', {
      ...getters.getSearchForm,
      page: 1,
      perPage: 10
    })
  }
}

export default actions